export default "__VITE_ASSET__Bt5X9YT3__"